import React, {Fragment, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {addMaterial, clearErrors, getMaterialUnits, getWarehouseOptions} from "../../actions/material";
import Select from "react-select";
import {getParams, getSelectedOption} from "../../utils/hooks/getParams";
import useActiveFirm from '../../hooks/useActiveFirm';


const MaterialCreateForm = ({
                                materials,
                                material_warehouses_options,
                                loading,
                                material_units,
                                error,
                                currentPage,
                                addMaterial,
                                getMaterialUnits,
                                getWarehouseOptions,
                                clearErrors,
                                handleClose,
                                show
                            }) => {
    const { firmId, firms } = useActiveFirm();

    const formRef = useRef();

    useEffect(() => {
        getMaterialUnits();
    }, [getMaterialUnits]);

    const [firmOptions, setFirmOptions] = useState([]);
    const [warehouseOptions, setWarehouseOptions] = useState([]);

    // Use firms from useActiveFirm hook instead of Redux firm_options
    useEffect(() => {
        let items = [];
        if (firms && firms.length > 0) {
            firms.forEach((item) => items.push({
                label: `${item.name}`,
                value: item.id
            }));
        }
        setFirmOptions(items);
    }, [firms]);

    useEffect(() => {
        let options = [];
        material_warehouses_options.forEach((item) => options.push({
            label: item.name,
            value: item.id
        }));
        setWarehouseOptions(options);
    }, [material_warehouses_options]);

    const defaultValues = {
        name: '',
        unit_id: '',
        firm_id: '',
        warehouse_id: '',
        unit_alternative_id: '',
        multiplier: '',
    };

    const [inputs, setInputs] = useState(defaultValues);
    const [errors, setErrors] = useState({});

    // Auto-populate with global firm when modal opens or firm changes
    useEffect(() => {
        if (show && firmId) {
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            getWarehouseOptions({ firm_id: firmId });
        }
    }, [show, firmId, getWarehouseOptions]);
    
    // Ensure firm_id is always set from global active firm
    useEffect(() => {
        if (firmId && inputs.firm_id !== firmId) {
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            if (show) {
                getWarehouseOptions({ firm_id: firmId });
            }
        }
    }, [firmId, show, getWarehouseOptions, inputs.firm_id]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {
            name: inputs.name,
            firm_id: Number(inputs.firm_id),
            warehouse_id: Number(inputs.warehouse_id),
            unit_id: Number(inputs.unit_id),
            unit_alternative_id: Number(inputs.unit_alternative_id),
            multiplier: Number(inputs.multiplier),
        };
        const params = getParams(true);
        // Always include firm_id from global active firm
        if (firmId) {
            params.firm_id = firmId;
        }
        // Include current page if available
        if (currentPage) {
            params.page = currentPage;
        }
        addMaterial(data, params);
    };

    const handleChange = e => {
        setErrors({});
        e.target.oldValue = e.target.value;
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value}));

        // bundan pastdagilar hamma formada kerak emas.
        if (e.target.name === 'name') {
            setMaterialName(e.target.value);
        }
        if (e.target.value && e.target.name === 'unit_id') {
            const unit = material_units.find(item => item.id === Number(e.target.value));
            setUnitName(unit.name);
        }
        if (e.target.value && e.target.name === 'unit_alternative_id') {
            const unit = material_units.find(item => item.id === Number(e.target.value));
            setUnitAlternativeName(unit.name);
        }
        if (e.target.name === 'multiplier') {
            setMultiplier(e.target.value);
        }
    };


    const handleSelect = (data, type) => {
        setErrors({});
        // Firm selection is handled by global firm switcher, not here
        setInputs(prevState => ({...prevState, [type.name]: data.value}))
    };


    const [unit_name, setUnitName] = useState('');
    const [unit_alternative_name, setUnitAlternativeName] = useState('');
    const [material_name, setMaterialName] = useState('');
    const [multiplier, setMultiplier] = useState('');

    useEffect(() => {
        if (error && loading === false) {
            const errorsItems = error?.errors;
            let errorObject = {};
            if (error && error?.errors) {
                Object.keys(error?.errors).forEach((item) => errorObject[item] = errorsItems[item][0]);
            }
            setErrors(errorObject);
        }
    }, [error]);

    useEffect(() => {
        clearErrors();
        setErrors({});
        setInputs(defaultValues);

        setUnitName('')
        setUnitAlternativeName('')
        setMaterialName('')
        setMultiplier('')
    }, [materials]);

    const onClose = () => {
        clearErrors();
        setInputs(defaultValues);
        setErrors({});
        handleClose();
    }

    return (
        <Fragment>
            <Modal show={show} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Yangi material qo'shish</Modal.Title>
                </Modal.Header>

                <Modal.Body className="pt-3 pb-4 mx-3">
                    <form onSubmit={handleSubmit} ref={formRef}>


                        <div className="mb-2">
                            <label htmlFor="name">Material nomi</label>
                            <input
                                name="name"
                                className={'form-control'}
                                type="text"
                                value={inputs?.name || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                                required
                            />

                            <div className="error">
                                {errors?.name}
                            </div>
                        </div>


                        <div className="mb-3">
                            <label htmlFor="firm_id">Sklad</label>
                            <Select
                                name={'warehouse_id'}
                                options={warehouseOptions}
                                value={getSelectedOption(inputs?.warehouse_id, warehouseOptions)}
                                onChange={handleSelect}
                                defaultValue={{label: 'Tanlang', value: ''}}
                            />
                            <div className="error">
                                {errors?.warehouse_id}
                            </div>
                        </div>


                        <div className="mb-2">
                            <label htmlFor="name">Kirim o'lchovi</label>
                            <select name="unit_id" id="unit_id"
                                    className="form-control"
                                    value={inputs?.unit_id || ''}
                                    onChange={handleChange}
                                    onKeyUp={e => e.target.oldValue = e.target.value}
                            >
                                <option value="">Tanlang</option>
                                {
                                    material_units.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>

                            <div className="error">
                                {errors?.unit_id}
                            </div>
                        </div>

                        <div className="mb-2">
                            <label htmlFor="unit_alternative_id">Chiqim o'lchovi</label>
                            <select name="unit_alternative_id"
                                    value={inputs?.unit_alternative_id || ''}
                                    id="unit_alternative_id"
                                    className="form-control"
                                    onChange={handleChange}
                                    onKeyUp={e => e.target.oldValue = e.target.value}
                            >
                                <option value="">Tanlang</option>
                                {
                                    material_units.map((item, index) => (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    ))
                                }

                            </select>
                            <div className="error">
                                {errors?.unit_alternative_id}
                            </div>
                        </div>


                        <div className="mb-2">
                            <label htmlFor="multiplier">
                                1 {`${unit_name} ${material_name} = ${multiplier} ${unit_alternative_name} ?`}
                            </label>
                            <input
                                name="multiplier"
                                className={'form-control'}
                                type="number"
                                value={inputs?.multiplier || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                onKeyUp={e => e.target.oldValue = e.target.value}
                                required
                            />

                            <div className="error">
                                {errors?.multiplier}
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <Button className="w-50" variant="secondary" type="button" onClick={onClose}>Bekor
                                qilish</Button>
                            <Button className="w-50" variant="primary" type="submit">Saqlash</Button>
                        </div>
                    </form>
                </Modal.Body>

            </Modal>
        </Fragment>
    );
};

MaterialCreateForm.propTypes = {
    addMaterial: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    material: state.material,
    loading: state.material.loading,
    materials: state.material.materials,
    material_warehouses_options: state.material.material_warehouses_options,
    error: state.material.error,
    material_units: state.material.material_units,
    material_unit_alternatives: state.material.material_unit_alternatives,
    currentPage: state.material.currentPage,
});


export default connect(mapStateToProps, {
    addMaterial,
    getMaterialUnits,
    clearErrors,
    getWarehouseOptions
})(MaterialCreateForm);
